import React, { Component } from 'react';
import {Row, Col, Container} from 'react-bootstrap';
import '../css/style.css';
import Preloader from '../appshell/Preloader/Preloader';
import { LazyLoadImage } from 'react-lazy-load-image-component'
import 'react-lazy-load-image-component/src/effects/blur.css';


class NationalGrid extends Component {

	  constructor(props) {
		super(props);
		this.state = {spinner: true}
	  
	  }
	
	  componentDidMount(){
		setTimeout(() => {
			this.setState({ spinner: false });
		  }, 1000);
	  }


    render() {


      return (

        <section>

{this.state.spinner ? <Preloader/> : true}


				  <Row className="hero-section d-flex position-relative align-items-center">
				<Container>
					<Row>
						<div className="col-12 col-md-6 hero-content">

							<h1>National Grid CO₂ Calculator</h1>
							<p className="mb-0 mt-4">
								<strong>My Role</strong>: UI/UX Designer</p>
							<p className="mb-0"><strong>Responsibilities</strong>: User flow design, component & pattern system creation, visual design refinement, responsive design, front-end styling collaboration (Next.js)</p>
							<p className="mb-0"><strong>Platform</strong>: Web (Desktop & Mobile)</p>
							<p><strong>Deliverables</strong>: <a  href="https://co2calculator.nationalgrid.com/" target="_blank" rel="noopener noreferrer">co2calculator.nationalgrid.com</a></p>


							
							
						</div>
					</Row>
				</Container>

				<div className="col-12 hero-image">
					<div className="hero-image-container">
						<LazyLoadImage 
							effect="blur" 
							src="./assets/img/national-grid/hero.webp" 
							className="hero-image-cover"
						/>
					</div>
				</div>

		          </Row>





		
	<section className="section1 section"  >
		<Container>
		<Row className="align-items-center" >
			
			<Col xs={12} >
			 <h2 >Overview & Design Approach</h2>
			 <p >
			 The National Grid CO₂ Calculator is a consumer-facing digital tool that helps homeowners estimate their current carbon emissions based on existing home equipment, while visualizing how switching to heat pump technologies could reduce emissions and generate long-term cost savings.
			 </p>
			 <p>
			 The experience translates complex energy data into a guided, approachable flow that balances accuracy and usability. Early design work focused on identifying what equipment users could realistically recognize, how much detail was necessary without creating friction, and how to structure questions so they felt intuitive rather than technical.
			 </p>
			 <p>
			 A reusable component and pattern system was developed to support multiple question types and input states, ensuring consistency across the experience while allowing the tool to scale over time.
			 </p>

			 </Col>
		</Row>
		<Row className="align-items-center" >
			 <Col xs={12} className="mt-4">
				<LazyLoadImage alt="National Grid Component System" effect="blur" src="./assets/img/national-grid/components.webp" className="img-fluid" />
				<p className="label" style={{textAlign: 'center'}}>Component & Pattern System</p>
			 </Col>
			 
			 </Row>
		</Container>
	</section>

	<section className="section2 section"  >
		<Container>
		<Row className="align-items-center" >
			
			<Col xs={12} md={6} >
			 <h2 >User Flow, Prototyping & System Design</h2>
			 <p >
			 Using the component system and aligning with the National Grid design system, we designed an end-to-end user flow that guides users from onboarding through input, calculation, and results.
			 </p>
			 <p>
			 The experience begins with a brief onboarding sequence to establish context and expectations. Users then answer structured questions related to their energy goals, current home equipment, and household energy usage.
			 </p>
			 <p>
			 Once inputs are complete, the tool calculates:
			 </p>
			 <ul className="mb-4">
				 <li>Current energy use and CO₂ emissions</li>
				 <li>Projected emissions if heat pump systems are adopted</li>
				 <li>Potential cost savings and environmental impact reductions</li>
			 </ul>
			 <p>
			 The results experience was designed with future expansion in mind, including report sharing and email delivery to support continued engagement beyond the initial session.
			 </p>
			 <p>
			 A high-fidelity prototype and walkthrough were created to validate the flow and review the experience with stakeholders.
			 </p>

			 </Col>
			 <Col xs={12} md={6} >
				<LazyLoadImage alt="Early User Flow Design" effect="blur" src="./assets/img/national-grid/version1.webp" className="img-fluid mb-4" />
				<p className="label" style={{textAlign: 'center'}}>Early Design Iteration</p>
				<video width="100%" height="auto" controls className="img-fluid">
					<source src="https://www.icfcreative.com/2024/national-grid/video-walk-through.mp4" type="video/mp4" />
					Your browser does not support the video tag.
				</video>
				<p className="label" style={{textAlign: 'center'}}>Video Walkthrough</p>
			 </Col>
			
			 
			 </Row>		
		</Container>
	</section>


	<section className="section1 section"  >
		<Container>
			 <Row className="align-items-center" >
			
			<Col xs={12} >
			 <h2 >Visual Refinement & Responsive Execution</h2>
			 <p >
			 Following client feedback, we refined the visual language to better reflect National Grid’s brand identity while improving clarity and usability.
			 </p>
			 <p>
			 We introduced National Grid’s iconic angled geometry into hero treatments and layout elements to strengthen brand presence. The color strategy was also adjusted by reducing the dominance of blue, resulting in a lighter, more breathable interface that improves readability across longer flows.
			 </p>
			 <p>
			 These refinements were applied consistently across desktop and mobile experiences, with careful attention to spacing, hierarchy, and touch interactions.
			 </p>
			 <p>
			 While my primary role was UI/UX design, I collaborated closely with developers to help translate the designs into a Next.js front-end, supporting reusable components, layout patterns, and responsive behavior to ensure design intent was preserved in production.
			 </p>

			 </Col>
			 <Col xs={12} md={6} className="mt-4">
				<LazyLoadImage alt="Desktop Mockup" effect="blur" src="./assets/img/national-grid/desktop-mockup.webp" className="img-fluid" />
				<p className="label" style={{textAlign: 'center'}}>Desktop Mockup</p>
			 </Col>
			 <Col xs={12} md={6} className="mt-4">
				<LazyLoadImage alt="Mobile Mockup" effect="blur" src="./assets/img/national-grid/mobile-mockup.webp" className="img-fluid" />
				<p className="label" style={{textAlign: 'center'}}>Mobile Mockup</p>
			 </Col>
			
			 
			 </Row>		
		</Container>
	</section>

	<section className="section2 section"  >
		<Container>
			<Row className="align-items-center" >
			
			<Col xs={12} md={9}>
			 <h2 >Recognition & Awards</h2>
			 <p >
			 The National Grid CO₂ Calculator has been recognized by the CSS Design Awards (CSSDA) for excellence in design and usability.
			 </p>
			 <div className="awards-container mt-4">
				<div className="award-item align-items-center">
					<div className="clients border d-flex align-items-center justify-content-center">
						<img src="./assets/img/homepage/cssda-award.webp" className="award-bullet" alt="CSSDA Award"/>
					</div>
					<span><strong>CSS Design Awards:</strong> Special Kudos, Innovation Award, UX Award, UI Award</span>
				</div>
			 </div>
			 <div className="mt-5">
				 <a href="https://www.cssdesignawards.com/sites/national-grid-co2-calculator/48602/" target="_blank" rel="noopener noreferrer" className="myButton">View on CSSDA</a>
			 </div>
			 </Col>
			 <Col xs={12} md={3}>
				<LazyLoadImage alt="CSSDA Awards" effect="blur" src="./assets/img/national-grid/award.webp" className="img-fluid" />
				<p className="label" style={{textAlign: 'center'}}>CSSDA Recognition</p>
			 </Col>
			
			 
			 </Row>		
		</Container>
	</section>
			




    </section>
		
	
      
      )
    }
  }
		
  export default NationalGrid;